import { createAction, props } from '@ngrx/store';
export enum AuthActionTypes {
    initAuth = '[Auth] init auth',
    initAuthFailure = '[Auth] init auth failure',
    signIn = '[Auth] sign in',
    signInSuccess = '[Auth] sign in success',
    signInFailure = '[Auth] sign in failure',
    forgotPassword = '[Auth] forgot password',
    forgotPasswordSuccess = '[Auth] forgot password success',
    forgotPasswordFailure = '[Auth] forgot password failure',
    signOut = '[Auth] sign out',
    register = '[Auth] register',
    registerSuccess = '[Auth] register success',
    registerFailure = '[Auth] register failure',
}

export const InitAuth = createAction(AuthActionTypes.initAuth);

export const InitAuthFailure = createAction(AuthActionTypes.initAuthFailure);

export const SignIn = createAction(AuthActionTypes.signIn, props<{ idNumber: string; password: string }>());

export const SignInSuccess = createAction(AuthActionTypes.signInSuccess, props<any>());

export const SignInFailure = createAction(AuthActionTypes.signInFailure, props<any>());

export const ForgotPassword = createAction(AuthActionTypes.forgotPassword, props<{ email: string }>());

export const ForgotPasswordSuccess = createAction(AuthActionTypes.forgotPasswordSuccess);

export const ForgotPasswordFailure = createAction(AuthActionTypes.forgotPasswordFailure);

export const SignOut = createAction(AuthActionTypes.signOut);

export const Register = createAction(AuthActionTypes.register,
    props<{
    email: string;
    password: string;
    organization?: string;
    confirmPassword: string;
    organizationName: string
}>()
);

export const RegisterSuccess = createAction(AuthActionTypes.registerSuccess, props<any>());

export const RegisterFailure = createAction(AuthActionTypes.registerFailure, props<any>());
